// extracted by mini-css-extract-plugin
export default {"container":"Faq_container__xgsbb","title":"Faq_title__ijbBs"};